import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {},
    existingPassword: "",
    slug: "", 
    logo: "",
    address: {},
    packages: [],
    documents:[],
    sharedDocumet:{},
    linkExpirationDate: null,
  },
  mutations: {
    setUserData(state, payload) {
      state.userInfo = payload;
    },
    setExistingPassword(state, payload) {
      state.existingPassword = payload;
    },
    setSlug(state, payload) {
      state.slug = payload;
    }, 
    setLogo(state, payload){
      state.logo = payload;
    },
    setAddress(state, payload){
      state.address = payload;
    },
    setPackages(state, payload){
      state.packages = payload;
    },
    setDocuments(state, payload){
      state.documents = payload
    },
    setLinkExpirationDate(state, payload){
      state.linkExpirationDate = payload
    }

  },
  actions: {

  },
  getters: {
    isLoggedIn: state => {
      return state.userInfo.loggedIn;
    },
    isPasswordChangeNeeded: state =>{
      return state.userInfo.isPasswordChangeNeeded;
    }
  },
  plugins: [
    createPersistedState({
      paths: ['userInfo', 'slug', 'logo', 'address', 'packages']
    })
  ]
})
